const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b99ad65531ea3ab6c91ad38b50ff2b82a02868ba"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sprout@sprout-place"]={id:"b99ad65531ea3ab6c91ad38b50ff2b82a02868ba"};
      